module.exports = __webpack_public_path__ + "static/media/select_arrow_down.dc8cb285.svg";